<template lang="">
    <div>
        <div>
            <h2 class="text-center m-0 py-3 text-default">
                Activités du medécin reférent
            </h2>
        </div>


        <div class="content__trajet bg-white shadow mt-5">
            <h2 class="text-center m-0 py-3 text-default">
                Activités medécin reférent Administratives Manuelles
            </h2>
            <hr class="m-0" />
            <div class="px-1 px-md-4 py-4">
                <div class="row justify-content-center px-md-6">
                    <div class="col-12 col-md-6 col-lg mr-md-2 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="recherchez par date....." 
                            v-model="searchDateM"></input>
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                    <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="Rechercher par motif de ligne de temps....." 
                            v-model="searchManuel"></input>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="px-1 px-md-6 py-4 content__scroll">
                    <div class="trajet__box accordion" role="tablist" v-for="(affiliation, index) in activite_medecin_referents_manuelles || filterManuel" :key="index">
                        <div v-for="(ligne_temps, key) in affiliation.ligne_temps " :key="index+'-'+key" v-if="ligne_temps.activites_referent_patients.length >0">
                            <div v-b-toggle="'accordion'+index+'_'+key" class="trajet__info trajet__active mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center">
                                <div class="trajet__info--text d-flex align-items-center fs-6">
                                    <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                    <span class="text-primary px-1">{{ formattedDate(ligne_temps.date_consultation) }}</span>
                                    <span class="text-default ml-5">{{ affiliation.package.description_fr }} ({{ formattedDate(affiliation.date_signature) }})</span>
                                    <span class="px-5 d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    
                                    <span class="text-default">{{ ligne_temps.motif.description }}</span>
                                </div>
                                <li class="trajet__info--state trajet__active--state"></li>
                            </div>
                            <b-collapse :id="'accordion'+index+'_'+key" class="mt-1" visible accordion="my-accordion" role="tabpanel">
                                <b-card class="border-0">
                                    <div>
                                        <ul class="trajet__item p-0 px-md-4" v-for="(item, index) in ligne_temps.activites_referent_patients" :key="index">
                                            <li class="d-flex l-none align-items-center p-0">
                                                <span class="text-muted d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i> ---- </span>
                                                <div class="trajet__item--box mx-2 px-2">
                                                    <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                                    <span class="text-primary px-1">{{ formattedDateTime(item.date_cloture) }}</span>
                                                    <span class="text-default w-100">
                                                        <p><span class="font-weight-bold">Activité:</span> {{ item.activites_medecin_referent.description_fr }}</p>
                                                        <p><span class="font-weight-bold">Commentaire:</span> {{ item.commentaire }}</p>
                                                        <p v-if="item.date_cloture"><span class="font-weight-bold">Date clôture:</span> {{ formattedDate(item.date_cloture) }}</p> 
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </b-card>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div> 
        </div>

        <div class="content__trajet bg-white shadow">
            <h2 class="text-center m-0 py-3 text-default">
               Activités isolées du medécin reférent (n'appartenant à aucune affiliation)
            </h2>
            <hr class="m-0" />
            <div class="px-1 px-md-4 py-4">
                <div class="row justify-content-center px-md-6">
                    <div class="col-12 col-md-6 col-lg mr-md-2 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="recherchez par date....." 
                            v-model="searchDate"></input>
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                    <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="Rechercher par motif de ligne de temps....." 
                            v-model="searchTrajet"></input>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="px-1 px-md-6 py-4 content__scroll">
                    <div class="trajet__box accordion" role="tablist" v-for="(activity, index) in filterTrajet" :key="index">
                        <div v-b-toggle="'accordion'+index" class="trajet__info trajet__active mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center">
                            <div class="trajet__info--text d-flex align-items-center fs-6">
                                <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                <span class="text-primary px-1">{{ formattedDateTime(activity.created_at) }}</span>
                                <span class="text-default ml-5">{{ activity.activites_medecin_referent ? activity.activites_medecin_referent.description_fr : '' }} {{ activity.motif }}</span>
                            </div>
                            <li class="trajet__info--state trajet__active--state"></li>
                        </div>
                        <b-collapse :id="'accordion'+index" class="mt-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card class="border-0">
                                <div>
                                    <ul class="trajet__item p-0 px-md-4">
                                        <li class="d-flex l-none align-items-center p-0">
                                            <span class="text-muted d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i> ---- </span>
                                            <div class="trajet__item--box mx-2 px-2">
                                                <i class="fa fa-calendar text-primary" aria-hidden="true" v-if="activity.date_cloture"></i>
                                                <span class="text-primary px-1" v-if="activity.date_cloture">{{ formattedDateTime(activity.date_cloture) }}</span>
                                               
                                                <span class="text-default w-100">
                                                    <p v-if="activity.createur">
                                                        Fait par <span class="font-weight-bold">{{ activity.createur.prenom.charAt(0).toUpperCase() + activity.createur.prenom.slice(1) }} {{ activity.createur.nom.toUpperCase() }}</span>
                                                    </p>
                                                    <p v-if="activity.etablissement">
                                                        <span class="font-weight-bold">Etablissement: </span>
                                                        <span v-html="activity.etablissement"></span>
                                                    </p>
                                                    <p v-if="activity.ligne_temp">
                                                        <span class="font-weight-bold">Ligne de temps: </span>
                                                        <span v-html="activity.ligne_temp"></span>
                                                    </p>
                                                    <p v-if="activity.commentaire">
                                                        <span class="font-weight-bold">Commentaire:</span> {{ activity.commentaire }}
                                                    </p>
                                                </span>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                </div>
            </div> 
        </div>
    </div>
  
</template>
<script>

import search from "@/_services/trajetService";
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import Multiselect from 'vue-multiselect'
import moment from "moment";
export default {
    name: "TrajetMedecinControle",
    components: {
        Multiselect,
    },

    props: ['dossier_medical_slug'],
    data() {
        return {
            activite_medecin_referents_manuelles: [],
            activites_medecin_referent_isoles: [],
            activites_medecins: [],
            activites_manuel: [],
            ligne_temps: {},
            searchTrajet: "",
            searchDate: null,
            searchManuel: "",
            searchDateM: null,
        }
    },
    methods: {
        formattedDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return date;
            }
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getActiviteMedecinReferent(dossier_medical_slug) {
            axios.get(`${AppConfig.apiUrl}/v1/parcours/${dossier_medical_slug}/activite_medecin_referents`, { headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` } })
                .then(res => {
                    this.activite_medecin_referents_manuelles = res.data.activites_medecin_referent_manuelles;
                    this.activites_medecin_referent_isoles = res.data.activites_medecin_referent_isoles;
                    if (this.activites_medecin_referent_isoles.length > 0) {
                        let activites_medecin_referent_isoles = [];
                        this.activites_medecin_referent_isoles.forEach(activity => {
                            activites_medecin_referent_isoles.push({
                                id: activity.activite_id,
                                motif: activity.activites_medecin_referent.description_fr,
                                created_at: activity.created_at,
                                date_cloture: activity.date_cloture,
                                etablissement: activity.etablissement.name,
                                ligne_temp: activity.ligne_temps ? activity.ligne_temps.motif.description : "",
                                createur: activity.createur,
                                commentaire: activity.commentaire,
                            })
                        });
                        this.activites_medecins = activites_medecin_referent_isoles;
                    }
                    
                    if (res.data.activites_medecin_referent_manuelles) {
                        let activite_medecin_referents_manuelles = [];
                        res.data.activites_medecin_referent_manuelles.forEach(j => {
                            let ligne_temp = [];
                            j.ligne_temps.forEach(item => {
                                ligne_temp.push({
                                    id: item.id,
                                    motif: item.motif.description,
                                    created_at: item.created_at,
                                    date_cloture: item.date_cloture,
                                })
                            });
                            let motifs = ligne_temp.map(item => item.id),
                            motifs_array = {};
                            motifs =  [...new Set(motifs)];
                            motifs.forEach(timelines => {
                                let motif = ligne_temp.find(i => i.id == timelines);
                                motifs_array = motif
                            });

                            this.ligne_temps = motifs_array;
                            
                            activite_medecin_referents_manuelles.push({
                                id: j.id,
                                motif: (this.ligne_temps.motif),
                                created_at: j.date_signature,
                                package: j.package.description_fr,
                                date_consultation: j.date_consultation,
                                commentaire: j.commentaire,
                            })
                            
                        });
                        this.activites_manuel = activite_medecin_referents_manuelles;
                    }

                })
                .catch((error) => {
                    //console.log("error ", error)
                });
        }
    },
    mounted() {
        this.getActiviteMedecinReferent(this.dossier_medical_slug);
    },
    computed: {
        filterTrajet() {
            // console.log(this.activites_medecin);
            return search(this.searchTrajet, this.searchDate, this.activites_medecins, this.activity)
        },
        filterManuel() {
            return search(this.searchManuel, this.searchDateM, this.activites_manuel, this.affiliation)
        },
    },
}
</script>
<style lang="">
    
</style>